/**
 * Command Registry
 *
 * Simple in-memory registry for module-provided slash commands.
 * Commands are keyed by lowercase name. Each command tracks
 * which module registered it for clean teardown.
 */
const commands = new Map();
export function registerCommand(cmd) {
    commands.set(cmd.name.toLowerCase(), cmd);
}
export function unregisterCommand(name) {
    commands.delete(name.toLowerCase());
}
export function unregisterModuleCommands(moduleId) {
    for (const [name, cmd] of commands) {
        if (cmd.moduleId === moduleId)
            commands.delete(name);
    }
}
export function getCommand(name) {
    return commands.get(name.toLowerCase());
}
export function getAllCommands() {
    return Array.from(commands.values());
}
export function getModuleCommands(moduleId) {
    return Array.from(commands.values()).filter(c => c.moduleId === moduleId);
}
//# sourceMappingURL=command-registry.js.map